import * as React from "react";
import isEven from "@functions/isEven";
import cx from "classnames";
import * as classess from "@styles/footer.module.css";

const Footer = (props) => {
  const counter = props.counter;
  const dateBegin = 2021;
  const dateNow = new Date().getFullYear();
  return (
    <footer
      className={cx(isEven(counter) ? classess.footerEven : classess.footerOdd)}
    >
        <span>
            &copy; Copyright {`${dateBegin} - ${dateNow}`}. All Rights Reserved.
        </span>
    </footer>
  );
};

export default Footer;
